import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import { getReorderConflictIndex } from '@editor2/services/conflictResolutionService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { getPageByElementId } from '@editor2/components/CourseChangesDiff/helpers';
import { filterByEntityId } from '../common/conflictResolutionHelper';

export class ElementModifiedDeletedConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId } = conflict;
		const initialParent = getPageByElementId(state.initialCourse.pages, entityId);

		const filteredInitial = filterByEntityId(initialParent.elements, entityId);
		const parentId = initialParent.family_id;

		state.initialCourse.pages.entities[parentId].elements = filteredInitial;
		state.changes.pages[conflict.entityId] = [ChangesStatus.New];

		// update element reorder conflict if exists
		const reorderConflictIndex = getReorderConflictIndex(state, parentId);
		if (reorderConflictIndex > -1) {
			state.conflicts[reorderConflictIndex].initial = filteredInitial;
		}
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId } = conflict;
		const initialParent = getPageByElementId(state.initialCourse.pages, entityId);
		const currentParent = state.pages.entities[initialParent.family_id];

		const filteredInitial = filterByEntityId(initialParent.elements, entityId);
		const filteredCurrent = filterByEntityId(currentParent.elements, entityId);

		const parentId = initialParent.family_id;

		state.initialCourse.pages.entities[parentId].elements = filteredInitial;
		state.pages.entities[parentId].elements = filteredCurrent;
		state.changes.elements[conflict.entityId] = [];

		const reorderConflictIndex = getReorderConflictIndex(state, parentId);
		if (reorderConflictIndex > -1) {
			state.conflicts[reorderConflictIndex].initial = filteredInitial;
			state.conflicts[reorderConflictIndex].current = filteredCurrent;
		}
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
